import { Pipe, PipeTransform } from '@angular/core';
import { convertDateToDateAgoString } from '../utilities/date.helpers';

@Pipe({
    name: 'dateAgo',
    pure: true,
})
export class DateAgoPipe implements PipeTransform {
    transform(value: any, random: number): any {
        if (value) {
            return convertDateToDateAgoString(value);
        }

        return value;
    }
}
